/**
 * The ONE client instance. Components never import this and never call `fetch`; data access
 * goes through the query hooks in `src/api/queries/` and the commands in `src/api/commands/`.
 */
import { LevelLoadClient } from "./client";
import { devFetch } from "./devTools";
import { currentSession } from "./session";

export const api = new LevelLoadClient({
  baseUrl: import.meta.env["VITE_API_BASE_URL"],
  getToken: () => currentSession().getToken(),
  // Both read from the one seam, per request rather than at construction: the tenant changes
  // while the client lives, and a value captured here would be the one the user signed in with
  // rather than the one they are looking at.
  getTenantKey: () => currentSession().tenantKey,
  fetch: devFetch,
});
